import { render, staticRenderFns } from "./ViewAssets.vue?vue&type=template&id=b4e0cf6c&scoped=true&"
import script from "./ViewAssets.vue?vue&type=script&lang=js&"
export * from "./ViewAssets.vue?vue&type=script&lang=js&"
import style0 from "./ViewAssets.vue?vue&type=style&index=0&id=b4e0cf6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e0cf6c",
  null
  
)

export default component.exports